import { render, staticRenderFns } from "./ShowBlackList.vue?vue&type=template&id=8bc6538a&scoped=true&"
import script from "./ShowBlackList.vue?vue&type=script&lang=js&"
export * from "./ShowBlackList.vue?vue&type=script&lang=js&"
import style0 from "./ShowBlackList.vue?vue&type=style&index=0&id=8bc6538a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc6538a",
  null
  
)

export default component.exports